import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from 'components/Modals';
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material';
import { IntegracaoContext } from 'contexts/IntegracaoContext';
import Input from 'components/Input';
import Button from 'components/Button';

const AddModal = ({ item, logo, onSubmit }) => {
  const defaultValues = { nome_integracao: '', api: item?.api };
  const { closeModal } = useModal();
  const { control, handleSubmit } = useForm({ defaultValues });
  const { postLoading } = useContext(IntegracaoContext);

  return (
    <>
      <DialogTitle>Adicionar Integração</DialogTitle>
      <DialogContent>
        <Grid container spacing={5}>
          <Grid item xs={12} textAlign="center">
            <Box
              src={logo}
              component="img"
              alt={item?.nome}
              height={100}
              maxWidth="60%"
              maxHeight="100%"
              sx={{ objectFit: 'contain' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Input
              control={control}
              name="nome_integracao"
              label="Nome da Integração"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSubmit(onSubmit)}
          loading={postLoading}
          variant="contained"
        >
          Salvar
        </Button>
        <Button onClick={closeModal} variant="contained" color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default AddModal;
